export const host = 'https://rfca-strapi.herokuapp.com'
